import React from 'react';
import './Awards.css';

import iconEnergy from './images/icon-energy.svg';
import iconFitwel from './images/icon-fitwel.svg';
import iconGresb from './images/icon-gresb.png';
import iconNareit from './images/icon-nareit.svg';
import iconnewsweek from './images/icon-newsweek.svg';

// @TODO: hard coded content which will need to be refactored for CMS integration
const Awards = () => {
    return (
        <section className="section responsibility-awards">
            <div className="container">
                <div className="columns">
                    <div className="column is-12 is-offset-1">
                        <div className='icons-wrapper'>
                            <div className="columns is-mobile is-multiline">

                                <div className="column is-half-mobile is-2-tablet is-2-desktop icon1">
                                    <div className="iconix iconGresb">
                                        <span className="helper"></span>
                                        <img src={iconGresb} alt={iconGresb} width="150" height="105" />
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Top Ranked Americas Office Company</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-2-tablet is-2-desktop icon2">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconNareit} alt={iconNareit} width="182" height="79" />
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Leader in the Light</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-2-tablet is-2-desktop icon4">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconEnergy} alt={iconEnergy} width="90" height="93" />
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Partner of the Year</span>
                                    </div>
                                </div>
                                <div className="column is-half-mobile is-2-tablet is-2-desktop icon3">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconnewsweek} alt={iconnewsweek} width="221" height="30" />
                                    </div>
                                    <div className="bodyCopy">
                                        <span>America’s Most<br /> Responsible Companies</span>
                                    </div>
                                </div>
                                {/* <div className="column is-half-mobile is-2-tablet is-2-desktop icon5">
                                    <div className="iconix">
                                        <span className="helper"></span>
                                        <img src={iconFitwel} alt={iconFitwel} width="179" height="46" />
                                    </div>
                                    <div className="bodyCopy">
                                        <span>Anti-Viral<br /> Response Certified</span>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

Awards.propTypes = {};

export default Awards;
